import React from "react";

const PageLoader = () => (
  <div className="crypto-inline-loader" role="status" aria-label="불러오는 중">
    <span />
  </div>
);

export default PageLoader;
